import { render } from "./OrderPartDiscount.vue?vue&type=template&id=8d22e6f6&scoped=true"
import script from "./OrderPartDiscount.vue?vue&type=script&lang=js"
export * from "./OrderPartDiscount.vue?vue&type=script&lang=js"

import "./OrderPartDiscount.vue?vue&type=style&index=0&id=8d22e6f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d22e6f6"]])

export default __exports__